import { StandardEvents } from '@shopify/events';

function updateSolixCartCount(quantity) {
  document.querySelectorAll('.solix-header__cart').forEach((trigger) => {
    let badge = trigger.querySelector('.solix-header__cart-count');

    if (quantity > 0 && !badge) {
      badge = document.createElement('span');
      badge.className = 'solix-header__cart-count';
      trigger.appendChild(badge);
    }

    if (badge) {
      badge.textContent = String(quantity);
      badge.hidden = quantity === 0;
    }
  });
}

function cartRequest(path, body) {
  const root = window.Shopify?.routes?.root || '/';
  return fetch(`${root}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      ...body,
      sections: ['cart-drawer-section'],
      sections_url: window.location.pathname,
    }),
  }).then(async (response) => {
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'Unable to update your cart.');
    return result;
  });
}

function refreshOpenCartDrawer(result) {
  const sectionHtml = result.sections?.['cart-drawer-section'];
  if (!sectionHtml) throw new Error('The cart could not refresh. Please try again.');

  const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const nextInner = parsed.querySelector('[data-hydration-key="cart-drawer-inner"]');
  const currentInner = document.querySelector('#cart-drawer [data-hydration-key="cart-drawer-inner"]');
  if (!nextInner || !currentInner) throw new Error('The cart could not refresh. Please try again.');
  currentInner.replaceWith(nextInner);
}

async function updateHeaderCountFromCart() {
  const root = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) return;
  const cart = await response.json();
  updateSolixCartCount(cart.item_count);
}

async function finishCoverUpdate(result) {
  refreshOpenCartDrawer(result);
  await updateHeaderCountFromCart();
}

async function handleCoverToggle(toggle) {
  const card = toggle.closest('[data-solix-cover-upsell]');
  if (!card || card.classList.contains('is-loading')) return;

  const isAdded = card.classList.contains('is-added');
  const selectedVariant = card.dataset.selectedVariant;
  const lineKey = card.dataset.lineKey;
  const status = card.querySelector('[data-solix-cover-status]');

  card.classList.add('is-loading');
  if (status) status.textContent = isAdded ? 'Removing cover...' : 'Adding your cover...';

  try {
    const result = isAdded
      ? await cartRequest('cart/change.js', { id: lineKey, quantity: 0 })
      : await cartRequest('cart/add.js', { items: [{ id: selectedVariant, quantity: 1 }] });
    await finishCoverUpdate(result);
  } catch (error) {
    card.classList.remove('is-loading');
    if (status) status.textContent = error.message;
  }
}

async function handleCoverVariant(choice) {
  const card = choice.closest('[data-solix-cover-upsell]');
  if (!card || card.classList.contains('is-loading')) return;

  const newVariant = choice.dataset.solixCoverVariant;
  const oldLineKey = card.dataset.lineKey;
  const wasAdded = card.classList.contains('is-added');
  const status = card.querySelector('[data-solix-cover-status]');
  const image = card.querySelector('.solix-cover-upsell__image');

  if (wasAdded && choice.classList.contains('is-selected')) return;

  card.dataset.selectedVariant = newVariant;
  card.querySelectorAll('[data-solix-cover-variant]').forEach((option) => {
    const selected = option === choice;
    option.classList.toggle('is-selected', selected);
    option.setAttribute('aria-selected', String(selected));
  });

  if (choice.dataset.variantImage && image) {
    image.src = choice.dataset.variantImage;
    image.srcset = '';
    image.alt = `Silicone cover color ${choice.dataset.variantTitle}`;
  }

  card.classList.add('is-loading');
  if (status) status.textContent = wasAdded ? 'Changing your cover color...' : 'Adding your cover...';

  try {
    if (wasAdded) await cartRequest('cart/change.js', { id: oldLineKey, quantity: 0 });
    const result = await cartRequest('cart/add.js', { items: [{ id: newVariant, quantity: 1 }] });
    await finishCoverUpdate(result);
  } catch (error) {
    card.classList.remove('is-loading');
    if (status) status.textContent = error.message;
  }
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-solix-cover-toggle]');
  if (toggle) {
    handleCoverToggle(toggle);
    return;
  }

  const variant = event.target.closest('[data-solix-cover-variant]');
  if (variant) handleCoverVariant(variant);
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart }) => {
      if (cart?.totalQuantity !== undefined) updateSolixCartCount(cart.totalQuantity);
    })
    .catch(() => {});
});

document.addEventListener('theme-drawer:open', (event) => {
  if (event.target?.id !== 'cart-drawer') return;
  document.querySelectorAll('.solix-header__cart').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
});

document.addEventListener('theme-drawer:close', (event) => {
  if (event.target?.id !== 'cart-drawer') return;
  document.querySelectorAll('.solix-header__cart').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
});
